import * as React from 'react'

const Mp4Icon = React.forwardRef<SVGSVGElement, React.SVGProps<SVGSVGElement>>(
  ({ ...props }, ref) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
      ref={ref}
      {...props}
    >
      <g clipPath="url(#clip0_7337_43570)">
        <path
          fill="#E9F0FA"
          d="m18 0 4 4v19a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1z"
        ></path>
        <path fill="#C2CDDE" d="M22 4h-4V0z"></path>
      </g>
      <rect width="22" height="10" x="1" y="10" fill="#6D56F8" rx="1"></rect>
      <path
        fill="#fff"
        d="M3.71 12.182H5l1.728 4.216h.068l1.727-4.216h1.29V18H8.8v-3.997h-.053l-1.608 3.98h-.756l-1.608-3.989h-.054V18H3.71zM10.96 18v-5.818h2.182q.67 0 1.125.25.457.25.69.687.236.435.236.989 0 .56-.235.994-.237.435-.696.685-.46.247-1.134.247h-1.446v-.866h1.304q.392 0 .642-.137a.86.86 0 0 0 .37-.375q.122-.239.122-.548t-.122-.546a.83.83 0 0 0-.373-.366q-.249-.133-.645-.133h-.965V18zm4.987-1.08v-.838l2.469-3.9h.699v1.193h-.426l-1.662 2.634v.045h3.446v.867zM18.723 18v-1.335l.011-.375v-4.108h.994V18z"
      ></path>
      <defs>
        <clipPath id="clip0_7337_43570">
          <path fill="#fff" d="M2 0h20v24H2z"></path>
        </clipPath>
      </defs>
    </svg>
  ),
)
Mp4Icon.displayName = 'Mp4Icon'

export { Mp4Icon }
